
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/lt/sub/duk",
      function () {
        return require("private-next-pages/lt/sub/duk.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/lt/sub/duk"])
      });
    }
  